import {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import ePartnerIcon from '../../resources/icon.png'
import {
    Header,
    Image,
    Grid
} from 'semantic-ui-react';
import { setActiveNavID } from '../../app/appNavConfigSlice';

import Registered from './Registered'
import UserRegistration from './user-registration/UserRegistration'

function Home() {
    const dispatch = useDispatch();
    const user = JSON.parse(window.localStorage.getItem('user'));
    useEffect(() => {
        dispatch(setActiveNavID('home'));
    })

    return (
        <Grid stackable textAlign='center' centered verticalAlign='bottom'>
            <Grid.Row>
                <Grid.Column textAlign='center'>
                    <Image circular size='medium' src={ePartnerIcon} centered />
                    <Header as='h2' style={{ marginTop: '20px' }}>
                        Welcome to the Hik-Partner Link Authorized Partners Portal
                        <Header.Subheader>
                            This portal is for Hikvison authorized partners only.
                        </Header.Subheader>
                        <Header.Subheader>
                            Authorized partners can use this portal to request partner ID.This platform should not be misused.
                        </Header.Subheader>
                    </Header>

                    {
                        !user.registered ?
                        <UserRegistration email={user?.email}/>
                        :
                        <Registered user={user} />
                    }

                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default Home;